export default "__VITE_ASSET__55915657__"